import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VCPM } from 'pcs-domain';
import { EnvironmentService } from '../environment.service';
import { ReportServiceRequestAdapterService } from '../report-service-request-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class ReportClientService {

  constructor(private http: HttpClient, private env: EnvironmentService, private adapater: ReportServiceRequestAdapterService) { }
  generateReport(product: string, version: string, project: VCPM.Project) {
    return this.http.post(this.env.config.reportServiceUrl + "/products/" + product + "/" + version, this.adapater.getReportServiceRequest(project), {responseType: 'blob', reportProgress: true, observe: 'events'});
  }

    convertBlodToFile(resp: any, filename: string) {
    var downloadURL = window.URL.createObjectURL(resp);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = `${filename}`;
    link.click();
  }
}
